export default __webpack_public_path__ + "assets/webgl/zones.34a75387.glb";